import { render, staticRenderFns } from "./WinsWinnerContacts.vue?vue&type=template&id=20d7b3f8&"
import script from "./WinsWinnerContacts.vue?vue&type=script&lang=js&"
export * from "./WinsWinnerContacts.vue?vue&type=script&lang=js&"
import style0 from "./WinsWinnerContacts.vue?vue&type=style&index=0&id=20d7b3f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports